export enum FormTemplateItemType {
    label = 'label',
    label_formated = 'label_formated',
    text_short = 'text_short',
    text_long = 'text_long',
    // text_formated = 'text_formated',
    choice_one = 'choice_one',
    choice_multiple = 'choice_multiple',
    date = 'date',
    sign = 'sign',
    before_after = 'before_after',
    fitzpatrick = 'fitzpatrick',
    hair_stroke = 'hair_stroke',
    text_formated = 'text_formated',
    image_gallery = 'image_gallery',
    image_paint = 'image_paint',
}

export enum FormTemplateItemTypeFriendly {
    label = 'Texto fixo',
    label_formated = 'Texto livre',
    text_short = 'Campo de digitação simples',
    text_long = 'Campo de digitação multilinha',
    // text_formated = 'Texto longo com formatação',
    choice_one = 'Campo de escolha única',
    choice_multiple = 'Campo de escolha múltipla',
    date = 'Campo de data',
    sign = 'Campo de assinatura',
    before_after = 'Campo de Antes e Depois',
    fitzpatrick = 'Tipo de pele (escala Fitzpatrick)',
    hair_stroke = 'Grossura do pêlo',
    text_formated = 'Editor de texto',
    image_gallery = 'Imagens',
    image_paint = 'Imagens com marcação',
}

export enum FormTemplateTypeEnum {
    anamnese = 'anamnese',
    atestado = 'atestado',
    contrato = 'contrato',
    questionario = 'questionario',
    receita = 'receita',
    recibo = 'recibo',
    termo = 'termo',
    outro = 'outro',
}

export enum FormTemplateTypeFriendlyEnum {
    anamnese = 'Anamnese',
    atestado = 'Atestado',
    contrato = 'Contrato',
    questionario = 'Questionário',
    receita = 'Receita',
    recibo = 'Recibo',
    termo = 'Termo',
    outro = 'Outro',
}
